<script setup lang="ts">
import type { PageArchiveEntryFragment, PageContactEntryFragment, PageEntryFragment, PageGlossaryArchiveEntryFragment } from '#graphql-operations'
import type { BlocksInterface } from '~/components/organisms/BlocksRenderer.vue'

const route = useRoute()

const page = await useCraftEntry<PageEntryFragment | PageArchiveEntryFragment | PageContactEntryFragment | PageGlossaryArchiveEntryFragment>({
  section: ['page'],
  slug: [(route.params.slug || 'homepage') as string],
})

useCraftSEO(page)
useI18nParams(page)
</script>

<template>
  <div class="page">
    <div v-if="page.__typename === 'pageArchive_Entry'">
      <ArchiveHero :data="page" />
      <ArchiveRenderer :type="page.archiveType" />
    </div>
    <ContactHero v-else-if="page.__typename === 'pageContact_Entry' && page.heroContact" :data="page.heroContact" />
    <div v-else-if="page.__typename === 'pageGlossaryArchive_Entry'" class="container">
      <div class="flex">
        <Breadcrumbs class="lt-lg:mx-auto" :data="page" />
      </div>
      <ArchiveGlossary :data="page" />
    </div>
    <LazyBlocksRenderer v-if="'blocks' in page && page.blocks?.length" :blocks="(page.blocks as BlocksInterface[])" />
  </div>
</template>
